<template>
  <div class="section" style="padding: 10px 0 0 20px">
    <span style="color:red;line-height: 30px;">注意:下述为简单的国际化示例,请通过操作屏幕右上角的语言切换 观察效果</span>
    <div style="padding-bottom: 5px;">{{ $t('i18nDemo.btnDesc') }}</div>
    <div>
      <el-button type="primary" size="mini">{{ $t('common.btn.query') }}</el-button>
      <el-button type="primary" size="mini">{{ $t('common.btn.new') }}</el-button>
      <el-button type="primary" size="mini">{{ $t('common.btn.edit') }}</el-button>
      <el-button type="danger" size="mini">{{ $t('common.btn.delete') }}</el-button>
      <el-button type="primary" size="mini" @click="toTip">{{ $t('i18nDemo.messageBtn') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'I18nDemo',
  methods: {
    toTip() {
      this.$message.success(this.$t('i18nDemo.message'))
    }
  }
}
</script>
